import Api from "../services/Api";
import store from "../redux/store"
import "cordova-plugin-purchase"
import "cordova-plugin-purchase/www/store"
import { isPlatform } from "@ionic/react";
import { checkIfProHasExpired, isInThePast, subscriptionId } from "./shop_helper";
import { goToPageWithState } from "./app_actions";
import { setPRO, setSTORE } from "../redux/actions/proActions";
import { addPro, addProBackend, removeProBackend } from "../redux/actions/logInActions";

declare interface Window { store: CdvPurchase.Store; }

// this sets the store to the global window object, only needed once when initializing
window.store = window.CdvPurchase.store

const Store: CdvPurchase.Store = window.store 
// const state = store.getState()
const api = Api.getInstance();

export const getPlatform = () => {
  let platform = undefined
  if(isPlatform('capacitor')) {
    if(isPlatform('ios')) {
      platform = CdvPurchase.Platform.APPLE_APPSTORE
    } else if(isPlatform('android')) {
      platform = CdvPurchase.Platform.GOOGLE_PLAY
    }
  } else {
    if(isPlatform('desktop')) {
      platform = undefined
    } else if(isPlatform('mobileweb')){
      platform = undefined
    }
  }
  return platform
}

export const initializeStore = async () => {
  const state = store.getState()

  return new Promise((resolve, reject) => {
    // console.log("******init", JSON.stringify(state))
    Store.validator = 'https://validator.iaptic.com/v3/validate?appName=wt&apiKey=d3eb0a3f-5aae-4c7b-b87b-633dd2207831&additionalData'
    Store.verbosity = CdvPurchase.LogLevel.QUIET;
    Store.applicationUsername = state.logIn.user.person.id
    Store.minTimeBetweenUpdates = 5000
    CdvPurchase.Internal.ExpiryMonitor.INTERVAL_MS = 5000;
    // Always register product before initialize, product returns undefined in when otherwise.
    Store.register({
      platform: isPlatform('android') ? CdvPurchase.Platform.GOOGLE_PLAY : CdvPurchase.Platform.APPLE_APPSTORE,
      id: subscriptionId(),
      type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
    })

    Store.when().productUpdated(product => {
      // console.log('productupdated', JSON.stringify(product), product.owned)

      if(product.owned) {
        if(state.logIn.user.WTTeams === false) {
          addProBackend()
        } 
      } else {
        if(state.logIn.user.WTTeams === true) {
          if(isInThePast(state.logIn.user.lastProExpires)) {
            removeProBackend(state.logIn.user.WTTeamsPurchaseId)
          } else {
            // store.dispatch(addPro(false))
            // reject()
          }
        }
      }  
    })

    //Transaction listeners.
    Store.when().pending(transaction => {
      // console.log('pending',transaction)
    })
    Store.when().approved(transaction => {
      // console.log('approved',transaction)
      transaction.verify()
    }).verified(receipt => {
      receipt.finish().then(() => {
        const product = Store.get(subscriptionId(), getPlatform()) as CdvPurchase.Product
        if(product.owned) {
          store.dispatch(addPro(true))
          resolve(true)
          if(state.logIn.user.WTTeams === false) {
            addProBackend()
            resolve(true)
          } 
        } else {
          if(state.logIn.user.WTTeams === true) {
            if(isInThePast(state.logIn.user.lastProExpires)) {
              removeProBackend(state.logIn.user.WTTeamsPurchaseId)
            } else {
              // store.dispatch(addPro(false))
              // reject()
            }
          }
        }  
      })
    }).finished(transaction => {
      const product = Store.get(subscriptionId(), getPlatform()) as CdvPurchase.Product
      // console.log('finished', transaction, JSON.stringify(transaction))

      // console.log('PRODUCT OWNED FINISHED', product.owned)
    })

    //Check ownership status.
    Store.when().receiptsReady(cb => {
      const product = Store.get(subscriptionId(), getPlatform()) as CdvPurchase.Product

      // console.log('receiptready',cb, product.owned)
    })

    Store.when().receiptsVerified(cb => {
      // console.log('receipt verified', cb)
      const product = Store.get(subscriptionId(), getPlatform()) as CdvPurchase.Product
      const offer = Store.get(subscriptionId())?.getOffer()
      // console.log('verifproduct:', product.owned, Store.owned(subscriptionId()))
      // console.log('backend:', state.logIn.user.WTTeams)
      // console.log('verifiedreceipst:', )

      // Check if product is owned here
      if(product.owned) {
        store.dispatch(addPro(true))
        resolve(true)
        if(state.logIn.user.WTTeams === false) {
          addProBackend()
          resolve(true)
        }
      } else {
        if(state.logIn.user.WTTeams === true) {
          if(isInThePast(state.logIn.user.lastProExpires)) {
            removeProBackend(state.logIn.user.WTTeamsPurchaseId)
          } else {
            // store.dispatch(addPro(false))
            // reject()
          }
        }
      }
    })

    Store.when().receiptUpdated(localReceipt => {
      // console.log('updated', localReceipt)
    })

    Store.error((e: any) => {
      reject()
      goToPageWithState('/walk/shop/error', e.message)
      store.dispatch(setPRO({
        ...state.store, 
        loading: false
      }))
    });

    // Make sure it is app.
    // console.log('GETPLATFORM', getPlatform())
    if(getPlatform() !== undefined) {
      Store.initialize().then(res => {
        // console.log('is initilised', )
      })

      Store.ready(() => {
        const product = Store.get(subscriptionId()) as CdvPurchase.Product
        // console.log(product, product.owned, JSON.stringify(product))
        const data = {
          loading: false,
          title: product.title,
          description: product.description,
          price: product.pricing ? product.pricing.price : undefined,
          currency: product.pricing ? product.pricing.currency : undefined,
          owned: product.owned,
          type: product.type,
          // expiryDate: product.expiryDate,
          // lastRenewalDate: product.lastRenewalDate,
        }
        store.dispatch(setPRO(data))

        storeIsReady().then(res => {
          if(res === true) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    }
  })
} 

const storeIsReady = async () => {
  return new Promise((resolve, reject) => {
    // console.log('the store is ready')
    store.dispatch(setSTORE(true))
  })
}
